import React from 'react';
export function TrustBar() {
  return <section className="w-full bg-bg-alt py-5 border-y border-border-light px-4 relative overflow-hidden" data-id="element-216">
      {/* Subtle gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-primary/5 to-transparent" data-id="element-217"></div>

      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-4 text-center relative z-10" data-id="element-218">
        <div className="flex items-center gap-2 text-2xl bg-white/5 px-4 py-2 rounded-full border border-white/10 shadow-inner" data-id="element-219">
          <span data-id="element-220">🇲🇽</span>
          <span data-id="element-221">🇪🇸</span>
          <span data-id="element-222">🇦🇷</span>
          <span data-id="element-223">🇨🇱</span>
          <span data-id="element-224">🇨🇴</span>
        </div>
        <p className="text-text-sec text-sm sm:text-base font-medium" data-id="element-225">
          Utilizado por más de{' '}
          <span className="font-bold text-primary drop-shadow-[0_0_8px_rgba(59,130,246,0.5)]" data-id="element-226">
            12,000 profesionales y estudiantes
          </span>{' '}
          en toda Latinoamérica y España.
        </p>
      </div>
    </section>;
}